module.exports = __webpack_public_path__ + "img/GH-kyujin-design003.8fb9e206.webp";